module.exports = "<p>\r\n  shared works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/wamp64/www/duetz.repos/angular4/src/app/_components/shared/shared.component.html
// module id = ../../../../../src/app/_components/shared/shared.component.html
// module chunks = 1